import { Instance, types } from 'mobx-state-tree';

import { getMentor, removeMentor, saveMentor } from '@common/api/mentors';
import User from '@common/models/Users/User';

const Mentor = types
	.compose(
		User,
		types.model({
			phone: types.maybeNull(types.string),
			position: types.maybeNull(types.string),
			personal_number: types.maybeNull(types.string),
			zoom_link: types.maybeNull(types.string),
			zoom_id: types.maybeNull(types.string),
			zoom_access_code: types.maybeNull(types.string),
		}),
	)
	.named('Mentor')
	.actions(() => ({
		_fetch: getMentor,
		_save: saveMentor,
		_remove: removeMentor,
	}));

export default Mentor;

export interface IMentorModel extends Instance<typeof Mentor> {}
